import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { BiExitFullscreen, BiFullscreen } from 'react-icons/bi';
import { Container, Title, FiltersWrap, Separator } from './styles';

import { TypeReport } from '../types';
import PeriodFilter from './PeriodFilter';
import ViewModeFilter from './ViewModeFilter';
import ButtonExport from './ButtonExport';

type HeaderProps = {
  disableExport: boolean;
  isLoadingExcel: boolean;
  typeReport: TypeReport;
  setTypeReport: Dispatch<SetStateAction<TypeReport>>;
  dataValue: number;
  setDataValue: Dispatch<SetStateAction<number>>;
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  exportExcel: () => void;
};

const Header: React.FC<HeaderProps> = ({
  disableExport,
  isLoadingExcel,
  typeReport,
  setTypeReport,
  dataValue,
  setDataValue,
  showModal,
  setShowModal,
  exportExcel,
}) => {
  const [titleReport, setTitleReport] = useState<string>(
    'Histórico de consumo '
  );
  useEffect(() => {
    if (typeReport === 'graph') {
      setTitleReport('Histórico de consumo');
    } else if (typeReport === 'list') {
      setTitleReport('Histórico de boletos');
    }
  }, [typeReport]);

  return (
    <Container>
      <Title>{titleReport}</Title>
      <FiltersWrap>
        <ViewModeFilter typeReport={typeReport} setTypeReport={setTypeReport} />
        <Separator />
        <PeriodFilter dataValue={dataValue} setDataValue={setDataValue} />
      </FiltersWrap>
      <ButtonExport
        disabled={typeReport === 'list' || disableExport}
        onClick={exportExcel}
        isLoadingExcel={isLoadingExcel}
      />
      {showModal ? (
        <BiExitFullscreen onClick={() => setShowModal((prev) => !prev)} />
      ) : (
        <BiFullscreen onClick={() => setShowModal((prev) => !prev)} />
      )}
    </Container>
  );
};

export default Header;
